var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-header'),(_vm.RULES_POPUP_STATE)?_c('Rules'):_vm._e(),_c('router-view'),_c('OverseaLogin'),_c('loading-mask'),_c('share-mask')],1)}
var staticRenderFns = []

export { render, staticRenderFns }